import React from 'react'
import COLOR from '../../global/Color'
import {
  Page, VendorHero, Main, Section, Eyebrow, SectionTitle, SubTitle,
  Lead, BodyText, SectionImage, CardRow, Card, CardTitle, CardText, VendorCta,
} from '../../components/inner/venderProduct/vendorUi'

import EternalImage from '../../assets/technologies/EternalImage02.png'

const Eternal = () => {
  return (
    <Page>
      <VendorHero
        title="Eternal"
        subtitle="전자 재료 · 특수 화학 · 석유화학 전문 대만 화학 소재 제조사 (1964년 설립)"
      />

      <Main>
        {/* 회사 소개 */}
        <Section>
          <Eyebrow>Company</Eyebrow>
          <SectionTitle>회사 소개</SectionTitle>
          <Lead>
            대만 Eternal Materials Co., Ltd.{' '}
            <a href="https://www.eternal-group.com/EN/Home" target="_blank" rel="noreferrer" style={{ color: COLOR.BLUE }}>
              (長興材料工業股份有限公司)
            </a>
            는 1964년에 설립된 화학 재료 및 제품을 전문으로 하는 대만의 선도적인 회사입니다.
            다양한 산업 분야에 걸쳐 제품을 공급하며, 주로 전자 재료, 특수 화학 제품, 석유화학
            제품 등에서 두각을 나타내고 있습니다.
          </Lead>
          <div style={{ height: 16 }} />
          <BodyText>
            특히 반도체 산업에서 중요한 역할을 하는 다양한 재료를 생산하고 있습니다. 반도체 제조
            공정에 필수적인 고성능 재료를 제공하며, 기술 혁신과 품질 개선에 중점을 두고 있습니다.
          </BodyText>
          <div style={{ height: 20 }} />
          <SectionImage src={EternalImage} alt="Eternal 반도체 재료 제품군" />
        </Section>

        {/* 주요 반도체 재료 */}
        <Section>
          <Eyebrow>Products</Eyebrow>
          <SectionTitle>주요 반도체 재료</SectionTitle>

          <SubTitle>Molded Underfill (MUF)</SubTitle>
          <CardRow>
            <Card>
              <CardTitle>개요</CardTitle>
              <CardText>
                Molded Underfill은 반도체 패키징에서 칩과 기판 사이의 공간을 채워주는 재료입니다.
                주로 반도체 칩의 기계적 스트레스를 완화하고, 열 사이클링으로 인한 신뢰성을
                향상시키기 위해 사용됩니다.
              </CardText>
            </Card>
            <Card>
              <CardTitle>주요 기능</CardTitle>
              <CardText>
                <b>스트레스 완화</b><br />
                반도체 칩과 기판 간의 열팽창 계수 차이로 발생하는 기계적 스트레스를 완화합니다.<br /><br />
                <b>열 관리</b><br />
                열 전달을 개선하여 칩의 열 관리를 돕습니다.<br /><br />
                <b>보호 기능</b><br />
                물리적 충격, 습기, 화학물질 등으로부터 칩을 보호합니다.
              </CardText>
            </Card>
            <Card>
              <CardTitle>응용 분야</CardTitle>
              <CardText>
                <b>플립칩 패키징</b><br />
                반도체 칩을 기판에 뒤집어 부착하는 플립칩 패키징에서 주로 사용됩니다.<br /><br />
                <b>칩 온 보드(COB)</b><br />
                칩을 직접 기판에 부착하는 COB 기술에서도 사용됩니다.
              </CardText>
            </Card>
          </CardRow>

          <SubTitle>Liquid EMC (Liquid Encapsulation Material Compound)</SubTitle>
          <CardRow>
            <Card>
              <CardTitle>개요</CardTitle>
              <CardText>
                액상 EMC(Liquid Encapsulation Material Compound)는 반도체 칩을 보호하기 위해
                사용되는 액체형 봉지 재료입니다. 주로 전자기기 내부의 반도체 소자를 보호하고
                안정성을 향상시키기 위해 사용됩니다.
              </CardText>
            </Card>
            <Card>
              <CardTitle>주요 기능</CardTitle>
              <CardText>
                <b>전기적 절연</b><br />
                전기적 절연을 제공하여 소자 간의 전기적 간섭을 방지합니다.<br /><br />
                <b>열 관리</b><br />
                열 전도성을 개선하여 소자의 열 방출을 돕습니다.<br /><br />
                <b>보호 기능</b><br />
                물리적 손상, 습기, 화학물질로부터 반도체 소자를 보호합니다.
              </CardText>
            </Card>
            <Card>
              <CardTitle>응용 분야</CardTitle>
              <CardText>
                <b>반도체 패키징</b><br />
                다양한 반도체 패키징 기술에서 사용됩니다.<br /><br />
                <b>전자기기</b><br />
                스마트폰, 태블릿, 컴퓨터 등 전자기기 내부의 반도체 소자 보호에 사용됩니다.
              </CardText>
            </Card>
          </CardRow>

          <SubTitle>Polyimide Dry Film Type</SubTitle>
          <CardRow>
            <Card>
              <CardTitle>개요</CardTitle>
              <CardText>
                Polyimide Dry Film Type은 우수한 열적, 기계적, 화학적 특성을 가진 고성능
                폴리머입니다. 높은 온도에서도 안정적인 특성을 유지하여 다양한 산업 분야에서
                널리 사용됩니다.
              </CardText>
            </Card>
            <Card>
              <CardTitle>주요 기능</CardTitle>
              <CardText>
                <b>내열성</b><br />
                고온에서도 안정적인 물리적, 화학적 특성을 유지합니다.<br /><br />
                <b>기계적 강도</b><br />
                우수한 기계적 강도와 유연성을 제공합니다.<br /><br />
                <b>화학적 저항성</b><br />
                다양한 화학물질에 대한 뛰어난 저항성을 가집니다.<br /><br />
                <b>전기적 절연성</b><br />
                우수한 전기적 절연 특성을 가집니다.
              </CardText>
            </Card>
            <Card>
              <CardTitle>응용 분야</CardTitle>
              <CardText>
                <b>전자산업</b><br />
                유연한 회로 기판, 반도체 제조 공정, 전기 절연 필름 등에서 사용됩니다.<br /><br />
                <b>항공우주산업</b><br />
                고온 환경에서의 기계적 안정성과 경량화 특성으로 항공기 부품에 사용됩니다.<br /><br />
                <b>의료산업</b><br />
                내열성과 화학적 저항성으로 의료 기기 및 장비에 사용됩니다.<br /><br />
                <b>기타 산업</b><br />
                자동차, 에너지, 산업용 기계 등 다양한 분야에서 활용됩니다.
              </CardText>
            </Card>
          </CardRow>
        </Section>
      </Main>

      <VendorCta title="Eternal 제품 문의 · 기술 상담" />
    </Page>
  )
}

export default Eternal
